export default "__VITE_ASSET__Cmwr8HZA__"